import {Component, input, OnChanges, OnDestroy, OnInit, output, OutputEmitterRef, SimpleChanges} from '@angular/core';
import {Subscription} from "rxjs";
import {DjangoApiService} from "../../../../shared/services/django-api.service";
import {LanguageService} from "../../../../shared/services/language.service";
import {LangChangeEvent, TranslateModule, TranslateService} from "@ngx-translate/core";
import {ActivatedRoute} from "@angular/router";
import {CardsBasicComponent} from "../../../../shared/components/cards/cards-basic/cards-basic.component";
import {MatChipListbox, MatChipOption} from "@angular/material/chips";
import {MatTooltip} from "@angular/material/tooltip";

@Component({
  selector: 'app-period-detail',
  standalone: true,
  imports: [
    TranslateModule,
    MatChipListbox,
    MatChipOption,
    CardsBasicComponent,
    MatTooltip
  ],
  templateUrl: './period-detail.component.html',
  styleUrl: './period-detail.component.css'
})
export class PeriodDetailComponent implements OnInit, OnChanges, OnDestroy {
  productSlug!: any;
  periodData!: any;
  selectedPeriod: any = [];
  selectedPeriodChange = output<any>();
  periodListInput = input<any>();

  currentLanguage!: string;
  langChangeSubscription: Subscription | null = null;

  private subscriptions: Subscription = new Subscription();


  constructor(
    private _apiService: DjangoApiService,
    private _languageService: LanguageService,
    private _translate: TranslateService,
    public _route: ActivatedRoute) {
  }


  ngOnInit() {
    this.setupLanguageSubscription();
    //this.getRouteParams();
    this.periodData = this.periodListInput();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['periodListInput']) {
      this.periodData = this.periodListInput();
      this.selectedPeriod = [];
    }
  }

  private setupLanguageSubscription(): void {
    this.currentLanguage = this._languageService.getLanguage();
    this.subscriptions.add(
      this.langChangeSubscription = this._translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.currentLanguage = event.lang;
      })
    );
  }

  private getRouteParams(): void {
    this._route.params.subscribe(params => {
      this._route.parent?.params.subscribe(parentParams => {
        this.productSlug = parentParams['productSlug'];
        //this.loadPeriodData();
        this.resetSelectedPeriod();
      });

    });
  }

  loadPeriodData() {
    this.subscriptions.add(
      this._apiService.fetchProductDetail(this.productSlug).subscribe({
        next: (res: any) => {
          this.periodData = res.periods;
        },
        error: (error) => {
          console.error('There was an error fetching the user information', error);
        }
      }));
  }

  selectPeriod(periodData: any){
    if(this.selectedPeriod == periodData){
      this.selectedPeriod = '';
    } else {
      this.selectedPeriod = periodData;
    }
    this.selectedPeriodChange.emit(this.selectedPeriod);
  }

  resetSelectedPeriod(){
    this.selectedPeriod = [];
    this.selectedPeriodChange.emit(this.selectedPeriod);
  }


  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

}
